import React from 'react';

function PortfolioGrid() {
    return (
        <div className="PortfolioGridContainer">

            <div className="GridCLI">
                <img src="/grid/CLI.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/community-literature-initiative">
                    <div className="CLI">
                        <p>COMMUNITY</p>
                        <p>LITERATURE</p>
                        <p>INITIATIVE</p>
                        <p className="GridSubtext">WEB DESIGN</p>
                    </div>
                </a>
            </div>

            <div className="GridWSP">
                <img src="/grid/WSP.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/world-stage-press">
                    <div className="WSP">
                        <p>WORLD STAGE</p>
                        <p>PRESS</p>
                        <p className="GridSubtext">WEB DESIGN</p>
                    </div>
                </a>
            </div>

            <div className="GridSLP">
                <img src="/grid/SLP.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/sims-library-of-poetry">
                    <div className="SLP">
                        <p>SIMS LIBRARY</p>
                        <p>OF POETRY</p>
                        <p className="GridSubtext">WEB DESIGN</p>
                    </div>
                </a>
            </div>

            <div className="GridFuelCycle">
                <img src="/grid/FuelCycle.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/fuel-cycle">
                    <div className="FuelCycle">
                        <p>FUEL CYCLE</p>
                        <p>INFOGRAPHIC</p>
                        <p className="GridSubtext">GRAPHIC DESIGN</p>
                    </div>
                </a>
            </div>

            <div className="GridCSS">
                <img src="/grid/CSS.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/css-sketchbook">
                    <div className="CSS">
                        <p>CSS SKETCHBOOK</p>
                        <p className="GridSubtext">WEB DESIGN</p>
                    </div>
                </a>
            </div>

            <div className="GridImager">
                <img src="/grid/imager.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/imager">
                    <div className="Imager">
                        <p>IMAGER</p>
                        <p className="GridSubtext">WEB DEVELOPMENT</p>
                    </div>
                </a>
            </div>

            <div className="GridJangSoo">
                <img src="/grid/JSS.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/jang-soo-sushi-bar">
                    <div className="JangSoo">
                        <p>JANG SOO</p>
                        <p>SUSHI BAR</p>
                        <p className="GridSubtext">WEB DEVELOPMENT</p>
                    </div>
                </a>
            </div>

            <div className="GridCOVID">
                <img src="/grid/COVID.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/covid-19-tracker">
                    <div className="COVID">
                        <p>COVID-19</p>
                        <p>TRACKER</p>
                        <p className="GridSubtext">WEB DEVELOPMENT</p>
                    </div>
                </a>
            </div>

            <div className="GridMCW">
                <img src="/grid/MCW.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/mcw-global">
                    <div className="MCW">
                        <p>MCW GLOBAL</p>
                        <p className="GridSubtext">GRAPHIC DESIGN</p>
                    </div>
                </a>
            </div>

            <div className="GridPDP">
                <img src="/grid/PDP.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/pi-delta-psi">
                    <div className="PDP">
                        <p>PI DELTA PSI</p>
                        <p className="GridSubtext">GRAPHIC DESIGN</p>
                    </div>
                </a>
            </div>

            <div className="GridHargreaves">
                <img src="/grid/Hargreaves.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/hargreaves-jones">
                    <div className="Hargreaves">
                        <p>HARGREAVES JONES</p>
                        <p className="GridSubtext">WEB CONSULTING</p>
                    </div>
                </a>
            </div>

            {/* <div className="GridMTAMan">
                <img src="/grid/CLI.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/mta-man">
                    <div className="MTAMan">
                        <p>MTA MAN</p>
                        <p className="GridSubtext">UX / UI</p>
                    </div>
                </a>
            </div> */}

            {/* <div className="GridUX">
                <img src="/grid/CLI.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/accessibility-in-foreign-countries">
                    <div className="UX">
                        <p>ACCESSIBILITY IN</p>
                        <p>FOREIGN COUNTRIES</p>
                        <p className="GridSubtext">UX RESEARCH</p>
                    </div>
                </a>
            </div> */}

            <div className="GridNAVI">
                <img src="/grid/NAVI.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/navi">
                    <div className="NAVI">
                        <p>NAVI</p>
                        <p className="GridSubtext">USER INTERFACE</p>
                    </div>
                </a>
            </div>

            <div className="GridMooMilk">
                <img src="/grid/MooMilk.jpg" width="100%" height="auto"></img>
                <a href="/portfolio/moo-milk">
                    <div className="MooMilk">
                        <p>MOO MILK</p>
                        <p className="GridSubtext">LOGO DESIGN</p>
                    </div>
                </a>
            </div>

        </div>
    )
}

export default PortfolioGrid;